import { Fragment } from 'react';
import classNames from 'classnames';
import { groupBy, map } from 'lodash';
import { Col, Row } from 'react-bootstrap';
import { AccordionSection } from '@medifind/containers';
import styles from './ClinicalTrialShared.module.scss';

const ClinicalTrialSponsors = ({ sponsors, isLoading }) => {
  return (
    <AccordionSection
      classes={{
        container: styles['accordian-container'],
        header: styles['accordian-header'],
        title: styles['accordian-title'],
        body: styles['accordian-body'],
      }}
      expandable
      title="Sponsors"
      isLoading={isLoading}
    >
      {map(groupBy(sponsors, 'leadOrCollaborator'), (value, key) => {
        return (
          <Row key={`${key}-sponsor`} className={styles['field-row']}>
            <Col>
              <span className={classNames(styles['section-body-text'], styles['bold'])}>
                {key === 'lead' ? 'Leads' : 'Collaborators'}:{' '}
              </span>
              {map(value, ({ name }, i) => {
                return (
                  <Fragment key={i}>
                    {i > 0 ? ', ' : null}
                    <span>{name}</span>
                  </Fragment>
                );
              })}
            </Col>
          </Row>
        );
      })}
    </AccordionSection>
  );
};

export { ClinicalTrialSponsors as default, ClinicalTrialSponsors };
